export default "__VITE_ASSET__0PgJxXqjw$KAl6PgZjQb5g__";